<template>
  <div class="d-none">
    <input type="file" @change="upload" ref="file" />
  </div>
</template>

<script>
import ProcessScheduleModel from "@/models/lab/ProcessScheduleModel";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";

export default {
  name: "ScheduleProcessUpload",

  mixins: { ToastNotifications },

  props: {
    process_schedule: {
      type: ProcessScheduleModel,
      default: () => null
    }
  },

  methods: {
    chooseFile() {
      this.$refs.file.click();
    },

    upload() {
      this.$emit("onUpload");
      let file = this.$refs.file.files[0];
      return this.process_schedule.uploadList(file).then(
        response => {
          this.quickSuccessToast(
            "Results were upload successfully",
            "You will be redirected to this schedules result management shortly..."
          );
          this.$emit("onUploadSuccess");
        },
        err => {
          this.quickWarningToast(
            "Results could not be uploaded",
            err && err.message ? err.message : "Please try again."
          );
          this.$emit("onUploadFailure");
        }
      );
    }
  }
};
</script>
